import { useTranslation } from "react-i18next";
import { useBookingUnitLabels } from "@majourneys/booking";

/**
 * What a chat card's price is charged per.
 *
 * Cards printed a bare "300 MAD", which guests read as per person whatever
 * the unit was (seen 2026-10-28). The API sends `priceType`, the
 * `prices.type` of the row the figure came from: 0 per person, 1 per hour,
 * 2 per night, 3 per vehicle or group. Type 3 names the vehicle ("per quad")
 * the way the booking flow does, never "per group" for a quad. An answer from
 * before the API sent the type gets no unit, rather than a guess.
 *
 * Same rules as the app's `features/discover/lib/price-unit.ts`.
 */
export function usePriceUnit(match: {
  priceType?: number | null;
  categorySlug?: string | null;
  slug?: string | null;
}): string | null {
  const { t } = useTranslation();
  const unit = useBookingUnitLabels(match.categorySlug, match.slug);
  switch (match.priceType) {
    case 0:
      return t("activity_preview.per_person");
    case 1:
      return t("activity_preview.per_hour");
    case 2:
      return t("activity_preview.per_night");
    case 3:
      return unit.per;
    default:
      return null;
  }
}
